import React, { useEffect } from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { Provider, useSelector } from "react-redux";
import store from "../store";
import StatusView from "./StatusView";
import { InfoWindow } from "@react-google-maps/api";
import { useHistory } from "react-router-dom";

let globalUserState = {};

const getIconForMarker = (markerData, category) => {
  const topView = true;
  const availableImageList = [];
  availableImageList.push("car");
  availableImageList.push("truck");
  availableImageList.push("motorcycle");
  availableImageList.push("tractor");
  availableImageList.push("bus");
  availableImageList.push("pickup");
  availableImageList.push("van");
  availableImageList.push("ambulance");
  availableImageList.push("three_wheeler");
  availableImageList.push("e_rickshaw");
  availableImageList.push("jcb");
  availableImageList.push("crane");
  availableImageList.push("mixer_truck");
  availableImageList.push("person");
  availableImageList.push("arrow");
  availableImageList.push("bicycle");
  availableImageList.push("animal");
  availableImageList.push("boat");
  availableImageList.push("ship");

  let categoryName = category || "car";
  if (!availableImageList.some((attribute) => attribute === category)) {
    categoryName = "car";
  }
  categoryName = "category_" + (topView ? "top_" : "") + categoryName;

  if (!markerData || !markerData.id) return categoryName + "_running";

  const inactiveList = globalUserState.inactive?.deviceIds || [];

  if (inactiveList.includes(markerData.id)) {
    return categoryName + "_in_active";
  }

  if (markerData.attributes && markerData.attributes.motion) {
    return categoryName + "_running";
  }
  if (markerData.attributes && markerData.attributes.ignition) {
    return categoryName + "_idle";
  }
  return categoryName + "_stopped";
};

const MapMarker = (props) => {
  const history = useHistory();

  const [mapMarker, setMapMarker] = React.useState(null);
  const { markerData } = props;
  const onLoad = (mapMarker) => {
    setMapMarker(mapMarker);
  };

  const userDeviceState = useSelector(
    (state) => state.userDeviceState.deviceState
  );

  globalUserState = userDeviceState || {};

  useEffect(() => {
    const img = document.querySelectorAll(
      `img[src='images/top_icons/${getIconForMarker(
        markerData,
        markerData.icon
      )}.png#${markerData.id}']`
    );
    if (img.length > 0) {
      img[0].style.transform = `rotate(${markerData.course}deg)`;
    }
  }, [markerData]);

  const onClick = () => {
    const { isInfoOpen, isSelected, markerData, onClick } = props;

    const isOpen = isSelected ? !isInfoOpen : true;

    onClick(isOpen, markerData.id);
  };

  const renderInfoWindow = () => {
    const { isInfoOpen, isSelected, markerData } = props;
    // const { mapMarker } = this.state;

    if (!isInfoOpen || !isSelected || !mapMarker) {
      return null;
    }

    return (
      <InfoWindow anchor={mapMarker} zIndex={1}>
        <StatusView
          markerData={markerData.positionData}
          deviceId={markerData.id}
          onShowDetails={(positionId) =>
            history.push(`/position/${positionId}`)
          }
        />
      </InfoWindow>
    );
  };
  return (
    <Marker
      onLoad={onLoad}
      onClick={onClick}
      position={markerData.position}
      options={{
        icon: {
          url: `images/top_icons/${getIconForMarker(
            markerData,
            markerData.icon
          )}.png#${markerData.id}`,
          scaledSize: new window.google.maps.Size(40, 40),
        },
      }}
    >
      {renderInfoWindow(markerData.id)}
    </Marker>
  );
};

const getIconBackgroundColor = (position) => {
  if (!position || !position.id) {
    return "black";
  }

  if (position.attributes && position.attributes.motion) {
    return "#00C49F";
  }

  if (position.attributes && position.attributes.ignition) {
    return "#FFBB28";
  }

  return "#E82C38";
};

const PositionsMap = ({ scaleSize, positions }) => {
  const [isInfoOpen, setIsInfoOpen] = React.useState(null);
  const [selectedMarkerId, setSelectedMarkerId] = React.useState(null);

  // const history = useHistory();
  const devices = useSelector((state) => state.devices.items);

  const createFeature = (position) => {
    const device = devices[position.deviceId] || null;
    return {
      id: position.deviceId,
      name: device ? device.name : "",
      icon: device && (device.category || "default"),
      position: {
        lat: position.latitude,
        lng: position.longitude,
      },
      course: position.course,
      markerColor: getIconBackgroundColor(position),
      positionData: position,
      attributes: position.attributes,
    };
  };

  const onClick = (isInfoOpen, selectedMarkerId) => {
    setIsInfoOpen(isInfoOpen);
    setSelectedMarkerId(selectedMarkerId);
  };

  return (
    <div>
      {positions.map((location) => {
        const markerData = createFeature(location);
        return (
          <MapMarker
            key={markerData.id}
            markerData={markerData}
            isSelected={markerData.id === selectedMarkerId}
            isInfoOpen={markerData.id === selectedMarkerId && isInfoOpen}
            onClick={onClick}
            scaleSize={scaleSize}
          />
        );
      })}
    </div>
  );
};

export default PositionsMap;
